const formatTooltipValue = (value, name) => {
  if (typeof value === 'number') {
    return [Math.round(value), name];
  }
  return [value, name];
};

export default formatTooltipValue;
